import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import { FCSelector } from '../../model/form-config.interface';
import {
  PAYOFF_PARTICIPATION_BASE_CAPPED,
  PAYOFF_PARTICIPATION_BASE_GLOBAL_CAP,
  SUMMARY_PRODUCT_TYPE,
} from './product-capture-field-selectors.consts';

export const CAPPED_RULE: FCSelector = {
  formControlNames: [PAYOFF_PARTICIPATION_BASE_CAPPED],
  options: [
    {
      id: true,
      effects: [
        {
          formControlNames: [PAYOFF_PARTICIPATION_BASE_GLOBAL_CAP],
          hidden: false,
        },
      ],
      concatFieldRules: [
        {
          formControlNames: [SUMMARY_PRODUCT_TYPE],
          options: [
            {
              id: ProductTypeEnum.DISCOUNT_CERTIFICATE,
              effects: [
                {
                  formControlNames: [PAYOFF_PARTICIPATION_BASE_GLOBAL_CAP],
                  defaultUnit: 'abs',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: false,
      effects: [
        {
          formControlNames: [PAYOFF_PARTICIPATION_BASE_GLOBAL_CAP],
          hidden: true,
          selectValues: [null],
        },
      ],
    },
  ],
};
